module.exports = __webpack_public_path__ + "static/media/bt_top_lifecheck_over.596c6e24.png";